import React from "react";
import styles from "./vtrg_custom_block.scss";
import VtrgVideo from "../vtrg_video/vtrg_video";

const VtrgVideoOnlyFull = ({ info }) => {
  const video = info ? info : {};

  return (
    <div className="vtrg-video-only-full">
      {video.video && <VtrgVideo video={video.video} />}
    </div>
  );
};

export default VtrgVideoOnlyFull;
